import React from 'react';

import { ContactProps } from './Contact.types';

export const Contact: React.FC<ContactProps> = ({}) => {
  return <>Contact</>;
};
